import React from 'react';
import { useTranslator } from 'tradera-lang';
import DfpAd from '@tradera/blueprint/components/lib/ads';
import ApplicationErrorBoundary from 'tradera-components/application-error-boundary/application-error-boundary';
import '@tradera/blueprint/components/lib/ads.css';

const LocalizedDfpAd = props => {
    const { t } = useTranslator();
    const text = {
        label: t('dfpAd_label')
    };
    return (
        <ApplicationErrorBoundary capture={false}>
            <DfpAd {...props} text={text} />
        </ApplicationErrorBoundary>
    );
};

export default LocalizedDfpAd;
